<template>
    <div class="hours-container">
        <transition name="component-fade" mode="out-in">
            <div v-if="hours.length!==0" class="hours-wrapper">
                <div v-for="(hour,index) in hours" :key="hour.id" @click="selectedHourEvent(hour)"
                    :class="[
                    'hour-item',
                    hour.id === selectedHourId ? 'active' : null,
                    ]"
                >
                    <div class="circle">
                        <div></div>
                    </div>
                    <span>{{hour.start}} - {{hour.end}}</span>
                </div>
            </div>
            <span v-if="hours.length===0" class="hours-container-empty-text" v-html="$t('lesson.NO_LESSONS_WORKLOAD')"></span>
        </transition>
    </div>
</template>

<script>
    import Calendar from '../../calendar/Calendar'
    import store from '@/store';
    import {rest} from "@/utils/utils";

    export default {
        name: "DaySchedule",
        components: {
            Calendar,
        },
        props: {
            initialDate: {
                type: String,
                default: ''
            },
            correct_date:{
                type: Boolean,
                default: true
            },
            hours:{
                type:Array,
                default:[]
            }
        },
        data: function () {
            return {
                selectedHourId: -1,
                isLoad: false,
            }
        },
        mounted(){
            console.log(this.hours);
        },
        methods: {
            selectedHourEvent(hour) {
                this.selectedHourId = hour.id;
                this.$emit('selectedHourEvent', hour);
            },
        }
    }
</script>

<style scoped lang="scss">
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .2s ease;
    }

    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }

    .hours-container-empty-text {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.5px;
        color: rgba(11, 16, 34, 0.3);
    }

    .hours-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .hours-wrapper {
        height: 28.5rem;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .hour-item {
        cursor: pointer;
        padding: 1.5rem 3.6rem 1.5rem 5.6rem;
        border-radius: 1rem;
        background: #F0F3F8;
        display: flex;
        align-items: center;
        transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        margin-top: 0.5rem;
        margin-right: 0.5rem;
        position: relative;

        .circle {
        width: 21px;
        height: 21px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #0B1022;
        border-radius: 100px;
        margin-right: 16px;
        left: 1.6rem;
        top: 50%;
        transform: translateY(-50%);
        position: absolute;

        div {
            border-radius: 100px;
            width: 11px;
            height: 11px;
            display: none;
        }
        }

        span {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.5px;
        color: #0B1022;
        }

        &:hover {
        box-shadow: 0px 2px 4px #D1D1D1;
        }

        &.active {
        box-shadow: 0px 2px 4px #D1D1D1;
        background-color: #CF0920;

        .circle {
            border: 2px solid white;

            div {
            display: block;
            background-color: white;
            }
        }

        span {
            color: white;
        }
        }
    }
</style>